import { showNotification } from '@mantine/notifications';
import { api } from '@repo/api-codegen/api/utils';
import { parse } from 'papaparse';

export const getFileData = async (
	e: ProgressEvent<FileReader>,
	file: File,
	fileExt: string | undefined
): Promise<Record<string, string>[] | null> => {
	if (fileExt === 'csv') {
		const csv = e.target?.result as string;
		const { data } = parse<Record<string, string>>(csv, {
			header: true,
		});
		return data;
	} else if (fileExt === 'xls' || fileExt === 'xlsx') {
		const form = new FormData();
		form.append('file', file);

		const response = await fetch(`${api()}file/convert_excel/`, {
			method: 'POST',
			body: form,
		});

		if (!response.ok) {
			showNotification({
				title: 'Conversion failed',
				message: 'Could not convert the Excel file',
				color: 'red',
			});
			return null;
		}

		const { data } = await response.json();
		return data;
	} else {
		showNotification({
			title: 'Invalid file type',
			message: 'Please upload a CSV or Excel file',
			color: 'red',
		});
		return null;
	}
};
